// Point headings carry the tag from addPointRagIcons
function isPointHeading(line: string): boolean {
  return line.startsWith("#### ") && line.includes("<RagIcon ");
}

// First item is the text before the first point, then one item per point
export default function splitPointSections(text: string): string[] {
  const sections = [[]] as string[][];
  text.split("\n").forEach(line => {
    if (isPointHeading(line)) {
      sections.push([]);
    }
    sections[sections.length - 1].push(line);
  });
  return sections.map(lines => lines.join("\n"));
}
